import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/mobius/result_bg.webp";
import { StaticImage } from "gatsby-plugin-image";

function Resultmobius() {
  return (
    <section
      className="result_mobius pt-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              <span style={{ color: "#214092" }}>Results and </span>
              Impact
            </h2>
            <p>
              The end of development process for the Android and iOS apps had a
              noteworthy influence on Mobius Risk Group's risk management
              practices..
            </p>
            <p>
              The apps offered users with swift access to critical market
              information, allowing them to make well-versed decisions in
              real-time
            </p>
            <p>
              The improved efficiency and convenience enabled by the mobile
              applications resulted in better-quality risk management results.
            </p>
            <p>
              Users testified higher approval levels and treasured the ease of
              managing their risks on the go.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1"
          >
            <StaticImage
              src="../../../images/case-studies/mobius/result_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={526}
              height={674}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Resultmobius;
